module.exports = __webpack_public_path__ + "static/img/192.9d16652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/192.png
// module id = 200
// module chunks = 10